import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { faBars } from '@fortawesome/free-solid-svg-icons';
import { AuthUser } from 'app/shared/models/class/auth/auth-user';
import { AuthService } from 'app/shared/services/auth/auth.service';
import { DataService } from 'app/shared/services/data/data.service';
import { UiService } from 'app/shared/services/ui/ui.service';
import { SubscriptionBaseComponent } from 'app/shared/subscription-base/subscription-base-component';

@Component({
  selector: 'app-main',
  templateUrl: './main.component.html',
  styleUrls: ['./main.component.scss']
})
export class MainComponent extends SubscriptionBaseComponent implements OnInit {

  @Output() toggleDrawer = new EventEmitter<string>();

  faBars = faBars;

  title = '';
  isLog!: boolean;
  user!: AuthUser;

  drawer: boolean = false;

  constructor(
    private authService: AuthService,
    private dataService: DataService
  ) {
    super();
  }

  ngOnInit(): void {
    this.initComponent();
  }

  onToggleSidenav(event: string = 'other'): void {
    this.toggleDrawer.emit(event)
  }

  private initComponent(): void {

    if (this.authService.getDecodedToken()) {
      this.authService.isLog$.next(true)
    }

    this.user = this.authService.getUser();
    this.initSub();
  }

  private initSub(): void {
    this.subscription
      .add(
        this.dataService.titleApp$.subscribe(title => {
          this.title = title;
        })
      )
      .add(
        this.authService.isLog$.subscribe({
          next: isLog => {
            this.isLog = isLog ? true : false;

          }
        })
      )
  }
}
